import { Component, OnInit, OnDestroy } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';



@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {

  isButtonDisabled:boolean

  constructor(private adminViewServices:AdminViewService ) {
    super();

  }

  ngOnInit(): void {
    super.ngOnInit()

     this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })

  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }


}